import { addLineItemToTransaction } from 'src/home-page/business-logic/sale-mode-router';
import { LineItemAddDto } from 'src/items-list/business-logic/service/interfaces/line-item-add.dto';
import { ItemAddType } from '../common/enumerations/item-add-type';
import { IItemLookup } from '../common/interfaces/dtos/IItemLookup';
import { IManualTare } from '../common/interfaces/dtos/IManualTare';
import { IItemInputData } from '../common/interfaces/IItemInputData';
import { getLinkedLineItems } from '../items-list/business-logic/line-item-builder';

export const NoneItemId = 'None';

export const sellLinkedItem = async (
  lineItem: LineItemAddDto,
  itemLookup: IItemLookup,
  linkedItemLookup?: IItemLookup,
  manualTare?: IManualTare,
  isTareModification = false,
): Promise<void> => {
  const lineItemWithLinkedItem: LineItemAddDto = { ...lineItem };
  if (linkedItemLookup && linkedItemLookup.itemId !== NoneItemId) {
    lineItemWithLinkedItem.linkedItems = getLinkedLineItems([linkedItemLookup]);
  }

  if (manualTare) {
    lineItemWithLinkedItem.tareWeight = {
      isTareOverride: true,
      tareValue: manualTare.value,
      isManualPercentage: manualTare.isPercentage,
      grossWeight: lineItem.tareWeight?.grossWeight ?? lineItem.quantity.value,
    };
  } else {
    lineItemWithLinkedItem.tareWeight = undefined;
  }

  if (isTareModification) {
    lineItemWithLinkedItem.itemAddType = ItemAddType.ModifyTareWeight;
  }

  //AddSerialNumberToLineItem(_lineItemWithLinkedItem);

  const inputData: IItemInputData = {
    entryMethod: lineItem.item.entryMethod,
    itemId: lineItem.item.id,
    quantity: lineItem.quantity.value,
    unitOfMeasureCode: lineItem.uomCode,
    quantityEntryMethod: lineItem.quantity.entryMethod,
    manualQuantity: 0,
  };

  await addLineItemToTransaction({
    lineItem: lineItemWithLinkedItem,
    inputData,
    itemLookup,
  });
};
